import { useCallback, useEffect, useState } from "react";

const MOVIE_KEY = "wljj_fav_movies";
const ACTOR_KEY = "wljj_fav_actors";
const EVENT = "wljj-favorites-changed";

function read(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

function write(key: string, value: string[]) {
  localStorage.setItem(key, JSON.stringify(value));
  window.dispatchEvent(new Event(EVENT));
}

export default function useFavorites() {
  const [movieIds, setMovieIds] = useState<string[]>([]);
  const [actorIds, setActorIds] = useState<string[]>([]);

  const sync = useCallback(() => {
    setMovieIds(read(MOVIE_KEY));
    setActorIds(read(ACTOR_KEY));
  }, []);

  useEffect(() => {
    sync();
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, [sync]);

  const toggleMovie = useCallback((id: string) => {
    const current = read(MOVIE_KEY);
    const next = current.includes(id)
      ? current.filter((x) => x !== id)
      : [...current, id];
    write(MOVIE_KEY, next);
    setMovieIds(next);
  }, []);

  const toggleActor = useCallback((id: string) => {
    const current = read(ACTOR_KEY);
    const next = current.includes(id)
      ? current.filter((x) => x !== id)
      : [...current, id];
    write(ACTOR_KEY, next);
    setActorIds(next);
  }, []);

  return {
    movieIds,
    actorIds,
    toggleMovie,
    toggleActor,
    isMovieFav: (id: string) => movieIds.includes(id),
    isActorFav: (id: string) => actorIds.includes(id),
  };
}